@if (!isWebMobile) {
    <div style="background-color: #F0F3F7">
        @if (false) {
            <div class="row">
                <div class="col-12">
                    <div class="footer-end text-center">
                        <p> {{ 'footer.copy_rights_text' | translate }} <i
                                class="fa fa-copyright" aria-hidden="true"></i>{{ today | localizedDate:'yyyy'}} {{ 'footer.reserved_rights' | translate }}
                            <br>
                        </p>
                    </div>
                </div>
            </div>
        }

        @if (true) {
            <div class="container custom-padding">
                <div class="row align-items-center justify-content-center text-center pt-20 pb-15">
                    <div>
                        <img src="assets/images/logos/logoCT.png"
                             alt="Ciaotickets Logo" class="img-fluid logo-img">
                    </div>
                </div>

                <div class="row justify-content-center text-center pb-15">
                    <div>
                        <div class="footer-menu-single">
                            <div class="footer-left">
                                @for (link of footerMenuLeft; track link) {
                                    <a [href]="link.fullUrl" class="footer-link">{{ link.label }}</a>
                                }
                            </div>
                            <div class="footer-center">
                                <a class="iubenda-cs-preferences-link footer-link" href="#">
                                    {{ 'footer.privacy' | translate }}
                                </a>
                            </div>
                            <div class="footer-right">
                                @for (link of footerMenuRight; track link) {
                                    <a [href]="link.fullUrl" class="footer-link">{{ link.label }}</a>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center text-center pb-20">
                    <div>
                        <div class="social-icons">
                            <a href="https://www.facebook.com/ciaotickets/" target="_blank" class="social-icon">
                                <img src="assets/images/logos/fb.png" alt="Facebook">
                            </a>
                            <a href="https://www.instagram.com/ciaotickets_official" target="_blank" class="social-icon">
                                <img src="assets/images/logos/ig.png" alt="Instagram">
                            </a>
                            <a href="https://twitter.com/Ciaotickets" target="_blank" class="social-icon">
                                <img src="assets/images/logos/x.png" alt="X">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="footer-copyy text-centerr">
            <div class="footer-content">
                <p class="company-name">{{ 'footer.company_name' | translate }}</p>
                <p class="legal-info">
                    {{ 'footer.legal_address' | translate }} - {{ 'footer.vat' | translate }}
                </p>
                <p class="copyright pt-5 pb-5">
                    {{ 'footer.copyright' | translate }} {{ today | localizedDate:'yyyy' }}
                    {{ 'footer.reserved_rights' | translate }}
                </p>
            </div>
        </div>
    </div>
}

@if (isWebMobile) {
    <div style="background-color: #F1F3F7">
        @if (false) {
            <div class="row">
                <div class="col-12">
                    <div class="footer-end text-center">
                        <p> {{ 'footer.copy_rights_text' | translate }} <i
                                class="fa fa-copyright"
                                aria-hidden="true"></i>{{ today | localizedDate:'yyyy' }} {{ 'footer.reserved_rights' | translate }}
                            <br>
                        </p>
                    </div>
                </div>
            </div>
        }

        @if (true) {
            <div class="container custom-padding">
                <div class="row align-items-center mb-3 ml-10 mr-10"
                     style="border-bottom: 1px solid #3B3B3B1A">
                    <div class="col-md-6 col-6 text-md-left mb-2 mt-2 mb-md-0 pl-0 text-centerr">
                        <img src="assets/images/logos/logoCT.png" style="height: 47px; width: 142px;"
                             alt="Ciaotickets Logo" class="img-fluid">
                    </div>
                    <div class="col-md-6 col-6 text-md-right text-centerr mb-2 mt-2 d-flex justify-content-end p-0"
                         id="share">
                        <a href="https://www.facebook.com/ciaotickets/" target="_blank" class="mt-2"
                           style="background-image: url('assets/images/logos/fb.png');"></a>
                        <a href="https://www.instagram.com/ciaotickets_official" target="_blank" class="mt-2"
                           style="background-image: url('assets/images/logos/ig.png');"></a>
                        <a href="https://twitter.com/Ciaotickets" class="me-3 mt-2 mr-0" target="_blank"
                           style="background-image: url('assets/images/logos/x.png');"></a>
                    </div>
                </div>
                <div class="row" id="info">
                    <div class="footer-menu-mobile">
                        <div class="footer-left">
                            @for (link of footerMenuMobileLeft; track link) {
                                <a [href]="link.fullUrl">{{ link.label }}</a>
                            }
                        </div>

                        <div class="footer-right">
                            <a class="iubenda-cs-preferences-link" href="#">
                                {{ 'footer.privacy' | translate }}
                            </a>
                            @for (link of footerMenuMobileRight; track link) {
                                <a [href]="link.fullUrl">{{ link.label }}</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="footer-copyy text-centerr">
            <div class="footer-content">
                <p class="company-name">{{ 'footer.company_name' | translate }}</p>
                <p class="legal-info">
                    {{ 'footer.legal_address' | translate }} - {{ 'footer.vat' | translate }}
                </p>
                <p class="copyright pt-5 pb-5">
                    {{ 'footer.copyright' | translate }} {{ today | localizedDate:'yyyy' }}
                    {{ 'footer.reserved_rights' | translate }}
                </p>
            </div>
        </div>
    </div>
}
